import '@babel/polyfill';
import Vue from 'vue';

import App from './App';
import router from './router';
import store from './store';

import axios from '@/axios';

import GetTextPlugin from 'vue-gettext';
import translations from './locale/translations.json';
import Meta from 'vue-meta';
import PortalVue from 'portal-vue';

import { createNamespacedHelpers } from 'vuex';


import ClickOutside from 'vue-click-outside';
import VueLazyload from 'vue-lazyload';
import VueFlashMessage from 'vue-flash-message';
import './components/_global.js';

// Import plugin style
import 'vue-flash-message/src/FlashMessage.css';

const { mapState, mapGetters } = createNamespacedHelpers('bmr');

/*
if (process.env.NODE_ENV !== 'development') {
    Sentry.init({ dsn: 'https://84e3c0a064ad4bd38a72c5ebaa152d21@sentry.libeo.com/9' });
}
*/

// Global plugins
Vue.directive('click-outside', ClickOutside);
Vue.use(VueLazyload, {
    preLoad: 1.3,
    error: '/static/img/placeholder-158-158.png',
    loading: '/static/img/placeholder-158-158.png',
    attempt: 1,
    observer: true,
});
Vue.use(VueFlashMessage, {
    createShortcuts: false,
    messageOptions: {
        timeout: 3000,
        important: true
    },
});
Vue.use(PortalVue);

// Page meta
Vue.use(Meta, {
    keyName: 'metaInfo', // the component option name that vue-meta looks for meta info on.
    attribute: 'data-vue-meta', // the attribute name vue-meta adds to the tags it observes
    ssrAttribute: 'data-vue-meta-server-rendered', // the attribute name that lets vue-meta know that meta info has already been server-rendered
    tagIDKeyName: 'vmid' // the property name that vue-meta uses to determine whether to overwrite or append a tag
});

// Populate user in store before anything else occurs
let user = window.localStorage.getItem('user');
if (user) {
    store.commit('bmr/SET_USER', JSON.parse(user));
}

let activeStore = window.localStorage.getItem('activeStore');
if (activeStore && activeStore !== 'null') {
    store.dispatch('bmr/updateActiveStore', JSON.parse(activeStore));
}

// Intercept Unauthorized (not logged in)
axios.interceptors.response.use(
    response => response,
    error => {
        if (error.response.status === 401) {
            store.dispatch('bmr/resetUser');
        }
        return Promise.reject(error);
    }
);

store.dispatch('bmr/updateLanguage', window.localStorage.getItem('language') || navigator.language.split('-')[0]);

let token = window.localStorage.getItem('token');
if (token) {
    axios.defaults.headers.common['Authorization'] = `Token ${token}`;
}

Vue.use(GetTextPlugin, {
    translations: translations,
    availableLanguages: {
        en_CA: 'English',
        fr_CA: 'Français'
    },
    defaultLanguage: `${store.state.bmr.language}_CA`,
    silent: true
});

Vue.prototype.axios = axios;

// Mixins
Vue.mixin({
    filters: {
        formatDate: (value, adjustTzOffset = false) => {
            let format = { month: 'long', day: 'numeric' };
            let date = new Date(value);
            if (adjustTzOffset) {
                date = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
            }

            if (new Date().getFullYear() !== date.getFullYear()) {
                format.year = 'numeric';
            }

            return date.toLocaleDateString(
                `${ localStorage.getItem('language') || navigator.language.split('-')[0]}-CA`, format
            );
        },
        getDate: value => {
            let date = new Date(value).getDate().toString();
            return date.length <= 1 ? '0' + date : date;
        },
        getLocalMonth: value => {
            return new Date(value).toLocaleDateString(`${ localStorage.getItem('language') || navigator.language.split('-')[0]}-CA`, { month: 'short' });
        },
        processRTEContent: value => {
            return value.replace(/<table/g, '<div class="rte-table-wrapper"><table').replace(/<\/table>/g, '</table></div>');
        },
    },
    computed: {
        ...mapState({ currentLanguage: 'language' }),
        ...mapGetters(['staticPages']),
    },
    methods: {
        localizedRoute (name, language = null) {
            language = language || this.currentLanguage;
            return `${name.split('-')[0]}-${language}`;
        },
        localizedTypedRoute (route, type, slug = null, preventBack = false, overrideBack = null) {
            if (!this.staticPages.length) {
                return '';
            }

            type = this.staticPages.filter(s => s.slug_fr === type || s.slug_en === type)[0] != null ? this.staticPages.filter(s => s.slug_fr === type || s.slug_en === type)[0].slug : null;

            let params = { type: type };
            if (slug) {
                params.slug = slug;
            }

            if (preventBack) {
                params.preventBack = preventBack;
            }

            if (overrideBack) {
                params.overrideBack = overrideBack;
            }

            return {
                name: this.localizedRoute(route),
                params: params
            };
        },
        localizedMonth (date) {
            return this.$gettextInterpolate(
                this.$gettext('<span class="activity-month">%{ month }</span><span class="activity-day">%{ day }</span>'), {
                    day: this.$options.filters.getDate(date),
                    month: this.$options.filters.getLocalMonth(date)
                }
            );
        },
    }
});

// Accessibility
window.addEventListener('keydown', changeState);
window.addEventListener('mousemove', changeState);

function changeState (e) {
    var keyCode = e.keyCode ? e.keyCode : false;
    if (keyCode === false || keyCode === 9 || keyCode === 13 || keyCode === 27 || keyCode === 37 || keyCode === 38 || keyCode === 39 || keyCode === 40) {
        document.documentElement.setAttribute('data-state', e.type);
    }
}


// Configs
Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js